if (!customElements.get('variant-label')) {
  class VariantLabelCard extends HTMLElement {
    constructor() {
      super();
      this.variantLabels = this.querySelectorAll('.js-variant-label');
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      if (this.variantLabels) {
        const variantLink = this.parentElement.parentElement.querySelector('.spf-product-card__title').querySelector('a');
        if (variantLink) {
          // observer used because app updates the attributes
          var observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              const url = mutation.target.getAttribute('href');
              const regex = /variant=(\d+)/;
              const match = url.match(regex);
              
              if (match) {
                const variantId = match[1];
                this.setVisibleVariantLabel(variantId);
              } 
            });
          });
          
          observer.observe(variantLink, {
            attributes: true
          });
        }

        if (this.dataset.currentVariantId) {
          this.setVisibleVariantLabel(this.dataset.currentVariantId);
        }
      }
    }

    setVisibleVariantLabel(variantId) {
      this.variantLabels.forEach((variantLabel) => {
        variantLabel.hidden = variantLabel.dataset.variantId.toString() !== variantId.toString();
      });
    }
  }

  customElements.define('variant-label-card', VariantLabelCard);
}
